import React from "react";
import {FormattedMessage} from "react-intl";
import {ThumbsUp, ThumbsDown, MessageSquareHeart} from "lucide-react";

// Instant-feedback chip. Color + thumb carry the sentiment so it reads as
// "positive feedback"; `response` is "positive" / "negative" / null, where null
// means the student was asked but didn't answer. Shared between the session rows
// and the detail panel so feedback is marked identically in both.
export default function FeedbackTag({response}) {
    if (response === "positive") {
        return <span className="feedback-badge positive">
            <ThumbsUp size={11} />
            <FormattedMessage id="analysis.hasFeedback" defaultMessage="Feedback" />
        </span>
    }
    if (response === "negative") {
        return <span className="feedback-badge negative">
            <ThumbsDown size={11} />
            <FormattedMessage id="analysis.hasFeedback" defaultMessage="Feedback" />
        </span>
    }
    return <span className="feedback-badge none">
        <MessageSquareHeart size={11} />
        <FormattedMessage id="analysis.feedbackNoResponse" defaultMessage="No feedback response" />
    </span>
}
